/**
 * Application entry point.
 * Sets up MSAL authentication, React Query, API client, SignalR, theme, and toast notifications.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "sonner";
import { AuthProvider } from "@/providers/auth-provider";
import { QueryProvider } from "@/providers/query-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import { ApiProvider } from "@/providers/api-provider";
import { SignalRProvider } from "@/providers/signalr-provider";
import { App } from "./App";
import "./styles/globals.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found. Ensure index.html has a <div id='root'> element.");
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <QueryProvider>
          <ApiProvider>
            <SignalRProvider>
              <App />
              <Toaster
                position="bottom-right"
                toastOptions={{
                  className: "bg-sc-surface backdrop-blur-[16px] text-sc-text border border-sc-glass-border shadow-sc",
                }}
              />
            </SignalRProvider>
          </ApiProvider>
        </QueryProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
